import { BannersController } from 'features/banners';
import { SearchWidgetController } from 'features/search-widget';

const controllers = [BannersController, SearchWidgetController];

export { controllers };
